import SearchBar from '../../components/SearchComponents/SearchBar'
import { connectSearch } from '../../components/HOCComponents/connectSearch'

export default connectSearch(SearchBar)
